import React, { useContext } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import Icon from './Icon';
import Button from './Button';

import ThemeContext from '../../theme/ThemeContext';
import ThemeIcons from '../../theme/Icons';

const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamily};
  * {
    font-family: ${(props) => props.theme.fontFamily};
  }
`;

const StyledModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  svg.fa-xmark {
    font-size: 18px;
  }
`;

const StyledModalHeaderIcon = styled.div`
  margin-right: 8px;
`;

const StyledModalHeaderTitle = styled.div`
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledModalBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledModalActionsWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export default function CustomModal({
  icon,
  title,
  isOpen,
  width = 600,
  height = 400,

  submitText = 'Submit',
  onSubmit,
  cancelText = 'Cancel',
  onCancel,

  submitDisabled,

  contentStyles = {},
  overlayStyles = {},
  onHide,
  children
}) {

  const theme = useContext(ThemeContext);

  const propConfig = {
    style: {
      content: {
        backgroundColor: theme.backgroundColor,
        borderRadius: `${theme.borderRadius}px`,
        border: `${theme.borderWidth}px solid ${theme.borderColor}`,
        width,
        height,
        padding: '12px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        ...contentStyles
      },
      overlay: { zIndex: 9999999999, backgroundColor: 'rgba(0, 0, 0, 0.3)', ...overlayStyles }
    },
    isOpen,
    onRequestClose: onHide,
    ariaHideApp: false
  };

  const iconNode = !icon ? null : (
    <StyledModalHeaderIcon>
      <Icon
        color={theme.fontColorPrimary}
        icon={icon}
        size="lg"
      />
    </StyledModalHeaderIcon>
  );

  return (
    <Modal {...propConfig}>
      <StyledWrapper theme={theme}>
        <StyledModalHeader>
          <StyledModalHeaderTitle theme={theme}>
            {iconNode}
            {title}
          </StyledModalHeaderTitle>
          {!onHide ? null : (
            <Button
              danger
              styles={{ padding: '2px 4px', marginRight: '4px' }}
              icon={ThemeIcons.misc.close}
              onClick={onHide}
            />
          )}
        </StyledModalHeader>
        <StyledModalBody>
          {children}
        </StyledModalBody>
        <StyledModalActionsWrapper>
          {!onCancel ? null : <Button onClick={onCancel} text={cancelText} styles={{ marginRight: '8px' }} />}
          {!onSubmit ? null : <Button onClick={onSubmit} text={submitText} disabled={submitDisabled} />}
        </StyledModalActionsWrapper>
      </StyledWrapper>
    </Modal>
  );

}
